// extracted by mini-css-extract-plugin
export default {"label":"CornerPicker_label__uS5v9","buttonGroup":"CornerPicker_buttonGroup__3i2Ik","button":"CornerPicker_button__H4Lo6"};